<template>
  <v-app>
    <router-view></router-view>
    <notifications 
        group="foo_notif" 
        position="bottom right"
        animation-type="velocity"
        :width="400"
      />
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  data () {
    return {
      //
    }
  }
}
</script>
